import { QueryHookOptions, useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { GetPhotoRequirements } from '../../../athena/types/GetPhotoRequirements';

export const QUERY = gql`
  query GetPhotoRequirements($requestId: String!) {
    webMaintenance {
      getPhotoRequirements(input: { maintenanceRequestId: $requestId }) {
        requirements
      }
    }
  }
`;

const useGetPhotoRequirements = (options?: QueryHookOptions<GetPhotoRequirements>) =>
  useQuery<GetPhotoRequirements>(QUERY, options);

export default useGetPhotoRequirements;
